<template>
    <div>
        <h3>Your mission</h3>
        <p>Your mission as Frontend Developer is to build a GUI that uses the <router-link to="/backend">Backend API</router-link>. Your GUI shall support:</p>
        <ul>
            <li>Listing current inventory</li>
            <li>Listing current recipes</li>
            <li>Adding items to the inventory <span class="comment">/* a.k.a. go shopping */</span></li>
            <li>Adding new recipes</li>
            <li>Removing existing recipes</li>
        </ul>
        <p>When clicking a recipe, one should:</p>
        <ul>
            <li>See the name and instructions of the recipe</li>
            <li>See the required ingredients</li>
            <li>Be able to edit all properties of the recipe</li>
        </ul>
        <p>Given that there is enough ingredients:</p>
        <ul>
            <li>Allow the user to bake / perform the recipe (yes, there is an API-call for this too!)</li>
        </ul>
        <p>Be creative, explore the API, and deliver an outstanding responsive web app!</p>
    </div>
</template>

<script>
export default {
    name: 'FrontendMission'
}
</script>